module.exports = __webpack_public_path__ + "img/healthy_page01_right.fe906fdc.gif";